import React, { useMemo } from 'react';
import { buildUiHelpers } from './sharedUi';

export default function ConfirmDialog({ open, message, onCancel, onConfirm, COLORS }) {
  const { Card, Btn } = useMemo(() => buildUiHelpers({ COLORS, th: {} }), [COLORS]);
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1300,
        background: 'rgba(7,16,21,0.72)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <Card style={{ maxWidth: '520px', width: '100%' }}>
        <h3 style={{ margin: '0 0 12px', fontSize: '18px' }}>Bestätigung</h3>
        <div style={{ color: COLORS.muted, fontSize: '14px', lineHeight: 1.7 }}>
          {message}
        </div>
        <div style={{ marginTop: '18px', display: 'flex', justifyContent: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
          <Btn onClick={onCancel} color="ghost">Abbrechen</Btn>
          <Btn onClick={onConfirm} color="red">Bestätigen</Btn>
        </div>
      </Card>
    </div>
  );
}
